import { render, staticRenderFns } from "./CustomTags.vue?vue&type=template&id=30f27707&scoped=true&"
import script from "./CustomTags.vue?vue&type=script&lang=js&"
export * from "./CustomTags.vue?vue&type=script&lang=js&"
import style0 from "./CustomTags.vue?vue&type=style&index=0&id=30f27707&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f27707",
  null
  
)

export default component.exports